import { ICellRendererParams } from "ag-grid-community";
import React from "react";
import { LineItem, Product, PurchaseItem } from "types";
import { useResource } from "@/hooks/useResource";

type GrossSalesRow = PurchaseItem & { lineItem: LineItem };

const getProductPath = (productName: string, variantName?: string) =>
    variantName ? `${productName} > ${variantName.split(" / ").join(" > ")}` : productName;

export const MerchandiseGrossSalesProductCell = ({ value, data, context }: ICellRendererParams<GrossSalesRow>) => {
    const id = typeof value === "string" ? value : (value as { id: string })?.id;
    const { data: product } = useResource<Product>(["products", id], null, { enabled: !!id });
    const productName = product?.name ?? (typeof value === "string" ? value : id ?? "");

    if (context?.target === "tag") {
        return <span className="no-translate">{productName}</span>;
    }

    const productPath = getProductPath(productName, data?.lineItem?.name);

    return (
        <span className="no-translate truncate" title={productPath}>
            {productPath}
        </span>
    );
};
